import { render } from "./ContactContent.vue?vue&type=template&id=1771cf08&scoped=true"
import script from "./ContactContent.vue?vue&type=script&lang=js"
export * from "./ContactContent.vue?vue&type=script&lang=js"

import "./ContactContent.vue?vue&type=style&index=0&id=1771cf08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1771cf08"

export default script